import { statusLabel } from '../format';

/** Status pill (Figma "PayslipStatus": rounded pill, Poppins Medium). Colour is never the only cue: the label is always text. */
export function StatusBadge({ status, variant = 'list' }: { status: string; variant?: 'list' | 'statement' }) {
  const key = status.toLowerCase();
  return (
    <span className={`cp-status cp-status--${key} cp-status--${variant}`} data-status={status}>
      {statusLabel(status)}
    </span>
  );
}
